export const sxDrawerPaper = { sx: { width: 1, maxWidth: 480 } };

export const sxP20 = {
  p: 2.5,
};

export const sxActionItem = (isSelected: boolean) => ({
  borderRadius: 1,
  backgroundColor: isSelected ? 'action.selected' : 'transparent',
  '&:hover': {
    backgroundColor: isSelected ? 'action.selected' : 'action.hover',
  },
});

export const sxActionButton = (actionTriggerColor?: string, isDisabled?: boolean) => ({
  borderRadius: 1,
  color: isDisabled ? 'text.disabled' : actionTriggerColor ? actionTriggerColor : 'grey.700',
  '&.Mui-disabled': {
    opacity: 0.5,
  },
});

export const sxActionIcon = {
  minWidth: 40,
  display: 'flex',
  justifyContent: 'center',
  mr: 2,
};

export const sxActionsList = {
  flex: 1,
  overflow: 'auto',
  p: 1,
};
